const config = {
  resetDelay: 180000, // 3 minutes
  colorTool: false,
  map: {
    minZoom: 13,
    maxZoom: 17,
  },
  bounds: {
    lng: [13.51112, 13.95881],
    lat: [50.82008, 51.16929],
  },
}

export default config
